<!--<template>-->
<!--<div id="app">-->
<!--<transition name="fade" mode="out-in">-->
<!--<router-view></router-view>-->
<!--</transition>-->
<!--</div>-->
<!--</template>-->
<template>
  <div id="app" class="app" ref="appMain">
    <!-- isAuditDetails初审详情是否显示菜单和头部 -->
    <navbar :show="true"></navbar>
    <sidebar v-if="isLogin" :show="sidebar.opened && !sidebar.hidden"></sidebar>
    <app-main :class="{ 'no-login': !isLogin }"></app-main>
    <back-top v-if="isLong"></back-top>
    <!--<footer-bar></footer-bar>-->
  </div>
</template>
<script>
/* eslint-disable */
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
import { Navbar, Sidebar, AppMain, FooterBar, BackTop } from './common/layout/';
import { mapGetters, mapActions } from 'vuex';
import Debugger from './common/js/Debugger';

export default {
  data() {
    return {
      isLong: false,
      scroll: 0,
    };
  },
  components: {
    Navbar,
    Sidebar,
    AppMain,
    FooterBar,
    NprogressContainer,
    BackTop,
  },
  beforeMount() {
    const { body } = document;
    const WIDTH = 768;
    const RATIO = 3;

    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect();
        let isMobile = rect.width - RATIO < WIDTH;
        this.toggleDevice(isMobile ? 'mobile' : 'other');
        this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },

  mounted() {
    window.addEventListener('keyup', e => {
      let keyCode = e.keyCode || e.which || e.charCode;
      if (e.altKey && e.shiftKey && (keyCode === 76 || keyCode === 108)) {
        Debugger.download('调试数据');
      }
    });
    window.addEventListener('scroll', () => {
      this.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (window.innerHeight) {
        this.winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        this.winHeight = document.body.clientHeight;
      }
      if (this.scroll > this.winHeight / 2) {
        this.isLong = true;
      } else {
        this.isLong = false;
      }
    });
  },

  computed: mapGetters({
    sidebar: 'sidebar',
    isLogin: 'isLogin',
    isAuditDetail: 'isAuditDetail',
  }),

  methods: mapActions(['toggleDevice', 'toggleSidebar']),
};
</script>

<!--<style lang="less">-->
<!--@import './assets/css/myskin.less';-->

<!--body {-->
<!--margin: 0;-->
<!--padding: 0;-->
<!-- -webkit-font-smoothing: antialiased;-->
<!--}-->

<!--#app {-->
<!--position: absolute;-->
<!--top: 0;-->
<!--bottom: 0;-->
<!--width: 100%;-->
<!--}-->

<!--.el-submenu [class^='fa'] {-->
<!--vertical-align: baseline;-->
<!--margin-right: 10px;-->
<!--}-->

<!--.el-menu-item [class^='fa'] {-->
<!--vertical-align: baseline;-->
<!--margin-right: 10px;-->
<!--}-->

<!--.toolbar {-->
<!--background: #f2f2f2;-->
<!--padding: 10px;-->
<!--//border:1px solid #dfe6ec;-->
<!--margin: 10px 0;-->
<!--.el-form-item {-->
<!--margin-bottom: 10px;-->
<!--}-->
<!--}-->

<!--.fade-enter-active,-->
<!--.fade-leave-active {-->
<!--transition: all 0.2s ease;-->
<!--}-->

<!--.fade-enter,-->
<!--.fade-leave-active {-->
<!--opacity: 0;-->
<!--}-->

<!--.menu-icon {-->
<!--display: inline-block;-->
<!--width: 24px !important;-->
<!--font-size: 15px;-->
<!--margin-right: 5px;-->
<!--text-align: center;-->
<!--}-->
<!--#nprogress .bar {-->
<!--background: #00b593 !important; //自定义颜色-->
<!--}-->
<!--</style>-->

<style lang="scss">
@import '~animate.css';

.animated {
  animation-duration: 0.377s;
}

@import '~bulma';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

html {
  background-color: whitesmoke;
}
.app {
  height: 100%;
  display: flex;
  flex: 1;
  overflow: auto;
}
.app-main {
  display: flex;
  flex: 1;
  width: 92vw;
  &.no-login {
    margin-left: 0;
  }
}
.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;
  #nprogress {
    $color: #48e79a;
    .bar {
      background: $color;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }
    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}

.el-pager {
  .number {
    border-radius: 0;
  }
}

.el-message-box__headerbtn {
  float: right;
  border: none;
  background-color: transparent;
  width: 0;
  height: 0;
}
</style>

<style lang="less">
@import '../src/assets/css/myskin.less';

html,
body {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?7430d8ee